/** Single source for merchant-facing app name and support contact. */
export const APP_DISPLAY_NAME = "Orbits FreeShipping Upsell App";

export const THEME_APP_EMBED_HANDLE = "free-shipping-bar";

export const SUPPORT_EMAIL = "support@orbitsdev.com";

export function openSupportEmail() {
  const url = `mailto:${SUPPORT_EMAIL}`;
  try {
    if (window.top && window.top !== window) {
      window.top.location.href = url;
    } else {
      window.location.href = url;
    }
  } catch {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
